/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { TextInput } from "@mantine/core";

import { isEmail, useForm } from "@mantine/form";
import React from "react";
import { addUserToWorkspace } from "../../../../services/workspaceMemberEndpoint";
import notify from "../../../../utils/notify";

type Props = {
  open: boolean,
  setOpen: ((value: boolean) => void)
  | (((value: boolean) => void) & React.FormEvent<HTMLDivElement>),
  workspaceId: string,
};

const InviteTeam = ({ open, setOpen, workspaceId }: Props) => {
  const form = useForm({
    initialValues: {
      email: "",
    },
    validate: {
      email: isEmail("Please provide a valid email address (e.g., example@example.com)."),
    },
  });
  if (!open) {
    return null;
  }

  const submitHandler = async () => {
    form.validate();
    if (form.isValid()) {
      try {
        await addUserToWorkspace({
          workspace_id: workspaceId,
          email: form.values.email,
          role_name: "Member",
        });
        notify({
          type: "success",
          messageList: ["Invite Sent Successfully"],
        });
        setOpen(false);
      } catch (err: any) {
        if (err.response?.status !== 0) {
          notify({
            heading: "Unknown Error",
            type: "failure",
            messageList: ["An unknown error occurred. Please try again later or contact our support team for assistance."],
          });
        }
      }
    }
  };

  return (
    <div className="fixed inset-0 z-[9000] flex items-center justify-center" onClick={() => { setOpen(false); }}>
      <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" />
      <form
        className="relative mx-4 flex flex-col rounded-lg border p-6 w-full max-w-[440px] bg-white"
        style={{ borderColor: "#EEEEEE", boxShadow: "0 6px 18px rgba(0,0,0,0.022), 0 3px 9px rgba(0,0,0,0.044), 0 1px 1px rgba(0,0,0,0.044)" }}
        onClick={(e) => { e.stopPropagation(); }}
      >
        <h2 className="text-[15px] font-semibold" style={{ color: "#181818" }}>Invite a team member</h2>
        <p className="mt-1 text-[13px]" style={{ color: "#5C6070" }}>
          Invite your RevOps lead to connect CRM, or a developer to install the tracking script.
        </p>
        <TextInput
          classNames={{ input: "text-sm" }}
          {...form.getInputProps("email")}
          className="mt-4 mb-2"
          id="email"
          placeholder="colleague@company.com"
          styles={{
            input: { height: 36, borderColor: "#D0D0D0", borderRadius: 5, fontSize: 13 },
          }}
        />
        <div className="flex justify-end items-center mt-4 gap-3">
          <button
            type="button"
            className="rounded-[5px] px-3 py-1 text-[12px] font-medium transition-colors"
            style={{ color: "#5C6070" }}
            onClick={() => { setOpen(false); }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rounded-[5px] border px-3 py-1 text-[12px] font-medium text-white"
            style={{ backgroundColor: "#8267E6", borderColor: "#6852BD" }}
            onClick={submitHandler}
          >
            Send invite
          </button>
        </div>
      </form>
    </div>
  );
};

export default InviteTeam;
